import React from "react";

import DashboardShell from "../dashboard/DashboardShell";

const AllCountriesDashboard = () => (
  <DashboardShell
    title="Countries"
    subtitle="Content footprint across every country in the platform."
    clickRoute="/countries"
    breadCrumbDefault={false}
  />
);

export default AllCountriesDashboard;
